module.exports = __webpack_public_path__ + "static/media/RealTimeCommunication_Elec_006.375c06c0.png";